export default __webpack_public_path__ + "static/media/central_andes_2_10.b4000a9e.JPG";